import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useData } from "../context/DataContext";

export default function DeleteConfirmModal({ record, tableId, onClose }) {
  const { deleteTask } = useData();
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState("");
  const [result,  setResult]  = useState(null);

  const taskName = record.fields?.["Task Name"] || "this task";
  const taskId   = record.fields?.["Task ID"]   || record.record_id;

  const handleDelete = async () => {
    setLoading(true); setError("");
    try {
      const data = await deleteTask(tableId, record.record_id);
      setResult(data || { success: true });
    } catch (e) {
      setError(e.message || "Delete failed.");
      setLoading(false);
    }
  };

  // Show success state
  if (result) {
    const successContent = (
      <div className="modal-overlay">
        <div className="modal" style={{ maxWidth: 420 }}>
          <div className="modal-header">
            <h3>✅ Deleted Successfully</h3>
          </div>
          <div className="modal-body" style={{ textAlign: "center", padding: "20px 24px 10px" }}>
            <div style={{ fontSize: 44, marginBottom: 12 }}>🗑️</div>
            <p style={{ fontSize: 14, fontWeight: 600, color: "var(--text-primary)", marginBottom: 8 }}>
              Task deleted from Lark
            </p>
            <div style={{ background: "var(--surface-2)", borderRadius: 8, padding: "12px 16px", textAlign: "left", fontSize: 13, border: "1px solid var(--border-subtle)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <span style={{ color: "var(--text-tertiary)" }}>Admin table record</span>
                <span style={{ color: "var(--success)", fontWeight: 600 }}>✓ Deleted</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ color: "var(--text-tertiary)" }}>User Task rows removed</span>
                <span style={{ color: result.userTasksDeleted > 0 ? "var(--success)" : "var(--text-disabled)", fontWeight: 600 }}>
                  {result.userTasksDeleted > 0 ? `✓ ${result.userTasksDeleted} deleted` : "None found"}
                </span>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    );
    return ReactDOM.createPortal(successContent, document.body);
  }

  const modalContent = (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 420 }}>
        <div className="modal-header">
          <h3>🗑️ Delete Task</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          {error && <div className="alert alert-error">⚠ {error}</div>}
          <div style={{ textAlign: "center", padding: "10px 0 20px" }}>
            <div style={{ fontSize: 44, marginBottom: 12 }}>⚠️</div>
            <p style={{ fontSize: 15, fontWeight: 600, color: "var(--text-primary)", marginBottom: 8 }}>
              Are you sure you want to delete?
            </p>
            <p style={{ fontSize: 13, color: "var(--text-tertiary)" }}>
              <strong>{taskId}</strong> — {taskName}
            </p>
            <div style={{ background: "var(--danger-light)", borderRadius: 8, padding: "10px 14px", marginTop: 16, fontSize: 12, color: "var(--danger)", textAlign: "left" }}>
              <strong>This will permanently delete:</strong>
              <ul style={{ marginTop: 6, paddingLeft: 16 }}>
                <li>The record from Admin table</li>
                <li>All matching rows in User Task table</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose} disabled={loading}>Cancel</button>
          <button className="btn btn-danger" onClick={handleDelete} disabled={loading}>
            {loading ? "Deleting..." : "🗑️ Yes, Delete All"}
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}
